import { authFetch } from "./authApi";

// ---------------------------------------------------------
// SUBMIT (create) a Freshbooks time entry for a lesson event
// ---------------------------------------------------------
export async function submitTimeEntry({ projectId, eventTitle, eventStart, eventEnd, notes, eventId }) {
  const res = await authFetch(`/time-entry/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      project_id: Number(projectId),
      event_title: eventTitle,
      event_start: new Date(eventStart).toISOString(),
      event_end: new Date(eventEnd).toISOString(),
      notes: notes || null,
      event_id: eventId,
    }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.detail || "Failed to submit time entry");
  }

  return res.json(); // { status, fb_time_entry_id, freshbooks_response }
}

// ---------------------------------------------------------
// UPDATE an existing Freshbooks time entry
// ---------------------------------------------------------
export async function updateTimeEntry(fbEntryId, { projectId, eventTitle, eventStart, eventEnd, notes }) {
  const res = await authFetch(`/time-entry/${fbEntryId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      project_id: Number(projectId),
      event_title: eventTitle,
      event_start: new Date(eventStart).toISOString(),
      event_end: new Date(eventEnd).toISOString(),
      notes: notes || null,
    }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.detail || "Failed to update time entry");
  }

  return res.json();
}

// ---------------------------------------------------------
// DELETE a Freshbooks time entry
// ---------------------------------------------------------
export async function deleteTimeEntry(fbEntryId) {
  const res = await authFetch(`/time-entry/${fbEntryId}`, {
    method: "DELETE",
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.detail || "Failed to delete time entry");
  }

  return res.json();
}
